import React, { useContext, useEffect } from "react";
import { IconButton } from '@mui/material';
import { FaEye } from 'react-icons/fa';
import { FiscalYearContext } from "../FiscalYear/FiscalYearContext";

// function ShowDetails({ fetchAccountsDetails, accountID, articleID }) {
//     const { fiscalYear } = useContext(FiscalYearContext);

//     return (
//         <div>
//             <IconButton>
//                 <FaEye style={{ color: '#284945' }} onClick={() => { fetchAccountsDetails(accountID, fiscalYear); }}
//                 />
//             </IconButton>
//         </div>
//     )
// }

function ShowDetails({ fetchAccountsDetails, accountID, articleID }) {
    const { fiscalYear } = useContext(FiscalYearContext);

    return (
        <div>
            <IconButton>
                <FaEye
                    style={{ color: '#284945' }}
                    onClick={() => {
                        if (articleID) {
                            fetchAccountsDetails(fiscalYear, accountID, articleID);
                        } else {
                            fetchAccountsDetails(accountID, fiscalYear);
                        }
                    }}
                />
            </IconButton>
        </div>
    );
}


export default ShowDetails;